<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-10">
        <h3 class="text-center">Relatório de Comissão por excedente de parcelas</h3>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-4">
                <label>Administradora</label>
                <br />
                {{ (form.administrator_id == null || form.administrator_id == '') ? 'Todas' : administrator }}
              </div>
              <div class="col-md-4">
                <label>Equipe</label>
                <br />
                {{ form.team_id == null ? 'Todas' : team }}
              </div>
              <div class="col-md-">
                <label>Filtrar por</label>
                <br />
                {{ date }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Intervalo</label>
                <br />
                {{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}
              </div>
              <div class="col-md-4">
                <label>Parcela</label>
                <br />
                {{ installment }}ª
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row" v-show="report.length > 0" v-for="iterator in report" :key="iterator.id">
      <div class="col-md-12"
        v-if="(
          iterator.proposalByAfterSale.proposals != undefined && Object.keys(iterator.proposalByAfterSale.proposals).length > 0
        ) || (
          iterator.proposalByManager.proposals != undefined && Object.keys(iterator.proposalByManager.proposals).length > 0
        ) || (
          iterator.proposalBySalesman.proposals != undefined && Object.keys(iterator.proposalBySalesman.proposals).length > 0
        ) || (
          iterator.proposalBySupervisor.proposals != undefined && Object.keys(iterator.proposalBySupervisor.proposals).length > 0
        )"
      >
        <div class="panel panel-danger">
          <div class="panel-body">
            <b>Administratora: {{ iterator.name }}</b>
            <first-installment-report
              v-if="iterator.proposalByAfterSale.proposals != undefined && installment == 1"
              :item="iterator.proposalByAfterSale"
              type="after-sales"
            ></first-installment-report>
            <other-installment-report
              v-if="iterator.proposalByAfterSale.proposals != undefined && installment == 2"
              :item="iterator.proposalByAfterSale"
              type="after-sales"
            ></other-installment-report>
            <first-installment-report
              v-if="iterator.proposalByManager.proposals != undefined && installment == 1"
              :item="iterator.proposalByManager"
              type="manager"
            ></first-installment-report>
            <other-installment-report
              v-if="iterator.proposalByManager.proposals != undefined && installment == 2"
              :item="iterator.proposalByManager"
              type="manager"
            ></other-installment-report>
            <first-installment-report
              v-if="iterator.proposalBySalesman.proposals != undefined && installment == 1"
              :item="iterator.proposalBySalesman"
              type="salesman"
            ></first-installment-report>
            <other-installment-report
              v-if="iterator.proposalBySalesman.proposals != undefined && installment == 2"
              :item="iterator.proposalBySalesman"
              type="salesman"
            ></other-installment-report>
            <first-installment-report
              v-if="iterator.proposalBySupervisor.proposals != undefined && installment == 1"
              :item="iterator.proposalBySupervisor"
              type="supervisor"
            ></first-installment-report>
            <other-installment-report
              v-if="iterator.proposalBySupervisor.proposals != undefined && installment == 2"
              :item="iterator.proposalBySupervisor"
              type="supervisor"
            ></other-installment-report>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <button type="button" @click="pdf()" class="btn btn-fill btn-info">PDF</button>
        <!--button-- type="button" @click="excel()" class="btn btn-fill btn-success">Excel</!--button-->
      </div>
    </div>
  </div>
</template>
<script>
import TableReportFirstInstallment from "@/components/elements/TableReportCommissionSurplusPerFirstInstallment";
import TableReportOthersInstallment from "@/components/elements/TableReportCommissionSurplusPerOthersInstallment";

export default {
  components: {
    "first-installment-report": TableReportFirstInstallment,
    "other-installment-report": TableReportOthersInstallment
  },
  computed: {
    administrators: {
      get() {
        return this.$store.state.administrators.itens;
      }
    },
    date() {
      var dates = [
        { id: "sale_at", name: "Data de Venda" },
        { id: "deployment_at", name: "Data Alocação" },
        { id: "pay_at", name: "Data de Pagamento" },
        { id: "pay_at-sale_at", name: "Data de Pagamento (volume por data da venda)" },
        { id: "due_at", name: "Data de Vencimento (apenas parcelas pagas)" },
        { id: "due_at-all", name: "Data de Vencimento (parcelas pagas e não pagas)" }
      ];

      if (this.form.date_by == undefined){
        return "Data de Pagamento"
      }

      let date = dates.find(date => date.id === this.form.date_by);

      if (date == undefined) {
        return "Data de Pagamento"
      }
      
      return date.name
    },
    end_at() {
      if (this.form.date_at == undefined) {
        return new Date();
      }

      return this.form.date_at[1];
    },
    init_at() {
      if (this.form.date_at == undefined) {
        return new Date();
      }
      
      return this.form.date_at[0];
    },
    installment() {
      if (this.form.installment == undefined) {
        return 1;
      }
      
      return this.form.installment;
    },
    report: {
      get() {
        return this.$store.state.reports.item;
      }
    },
    teams: {
      get() {
        return this.$store.state.teams.itens;
      }
    },
  },
  data() {
    return {
      administrator: '',
      form: {},
    };
  },
  methods: {
    close() {
      window.opener.focus();
      window.close();
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");

      response.then(function(_administrators) {
        var administrator = _administrators.find(
          administrator => administrator.id === self.form.administrator_id
        );
        if (administrator !== undefined) {
          self.administrator = administrator.name;
        }
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });
    },
    async getDataReport() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch(
        "reports/commissionSurplusPerInstallment",
        self.form
      );

      response.then(function() {
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    async getDataTeams() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("teams/all");

      response.then(function(_teams) {
        var team = _teams.find(team => team.id === self.form.team_id);
        if (team !== undefined) {
          self.team = team.name;
        }
        self.$root.$emit("onLoading");
        self.getDataReport();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getDataReport();
      });
    },
    pdf() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch(
        "reports/commissionSurplusPerInstallmentDownloadInPdf",
        self.form
      )

      response.then(function(_downloadPdf) {
          let filename = 'commissions-by-profile.pdf'
          let blob = new Blob([_downloadPdf], {type: 'application/pdf'});

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click();

          self.$root.$emit("onLoading")
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    print() {
      window.print();
    },
  },
  mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);

    self.getDataAdministrators();
  }
};
</script>
<style type="scss">
@media print {
  .page{
    margin: 5%;
  }
  .dont-print {
    display: none;
  }
  .table{
    width: 80%;
  }
  .table .thead-dark th {
    color: #aaaaaa;
  }
  .panel-danger {
    border-color: #ebccd1;
    width: 93%;
    margin-left: 4%;
}
}
</style>